<template>
  <div>
    <el-row>
      <el-col>
        <p>产品名称：{{ proName }}</p>
        <p>单位：{{ proUnit }}</p>
        <p>供应商：{{ getMsg.NAME }}<el-button style="margin-left: 20px" :disabled="disabled" @click="openA">点击查看供应商资质
          </el-button>
        </p>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <p>流通过程：</p>
      </el-col>
      <el-col>
        <el-steps :active="flag" finish-status="success" :space="200">
          <el-step :title="item.T" :description="String(item.D)" v-for="(item, index) in stepList" :key="index">
          </el-step>
        </el-steps>
      </el-col>
      <el-col v-if="bcaimg.length != 0">
        <p>产品资质：</p>
      </el-col>
      <el-col v-if="bcaimg.length != 0">
        <p>农残检测报告：</p>
        <el-row style="margin-top：10px">
          <el-col :span="4" v-for="(item, index) in getMsg.FILE_URL" :key="index">
            <el-card :body-style="{ padding: '0px' }">
              <img :src="item.FILE_URL" class="image" style="width: 100%">
              <div style="padding: 10px;">
                <p>上传日期：{{ item.CREATE_TIME }}</p>
                <el-button type="text" class="button" @click="openImg(item.FILE_URL)">查看大图</el-button>
                <el-button type="text" class="button" @click="downloadImg(item.FILE_URL)">下载文件</el-button>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
      <el-col>
        <el-dialog title="农残检测报告" center :visible.sync="imgFormVisible" width="500px" :close-on-click-modal="false">
          <img :src="imgSrc" class="image" style="width: 100%">
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tmpImg: require('@/assets/images/timg.jpg'),
      imgFormVisible: false,
      getMsg: {},
      proName: '',
      proUnit: '',
      stepList: [],
      imgSrc: '',
      flag: 0,
      bcaimg: [],
      disabled: true,
    };
  },
  created() {
    this.proName = sessionStorage.getItem('pro_name_T');
    this.proUnit = sessionStorage.getItem('pro_unit_T');
    this.getList();
  },
  methods: {
    // 获取列表
    getList() {
      const params = {
        SERVICE_ID: '10031',
        OTYPE: 65,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PRODUCT_CODE: this.$route.params.id,
        BATCH: this.$route.params.code,
      };
      http.post(params).then((result) => {
        if (result.lentgh != 0) {
          if (result[0].OR.length != 0) {
            this.getMsg = result[0].OR[0];
            this.bcaimg = this.getMsg.FILE_URL;
            this.disabled = false;
          } else {
            this.disabled = true;
          }
          this.stepList = result[0].list[0].DATA;
          this.flag = result[0].list[0].RN;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openImg(img) {
      this.imgSrc = img;
      this.imgFormVisible = true;
    },
    openA() {
      sessionStorage.setItem('supplier_T', this.getMsg.NAME);
      this.$router.push({ path: `/supplierContract/${this.getMsg.SUPPLIER_ID}`, params: { id: this.getMsg.SUPPLIER_ID } });
    },
    downloadIamge(imgsrc, name) { // 下载图片地址和图片名
      const image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous');
      image.onload = function () {
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        const url = canvas.toDataURL('image/png'); // 得到图片的base64编码数据
        const a = document.createElement('a'); // 生成一个a元素
        const event = new MouseEvent('click'); // 创建一个单击事件
        a.download = name || 'photo'; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    downloadImg(img) {
      this.downloadIamge(img, 'pic');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tracing/tracingContract.vue